import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import Modal from './Modal';

const FE_BASE_URL = process.env.REACT_APP_FE_BASE_URL;

function OrganizationInviteModal({ organization, onClose }) {
  const [copied, setCopied] = useState(false);
  const qrRef = useRef(null);

  const inviteUrl = `${FE_BASE_URL}/auth/register?organization_id=${organization.id}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      window.prompt('Sao chép link mời:', inviteUrl);
    }
  };

  const handleDownload = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;

    const link = document.createElement('a');
    link.download = `invite-qr-${organization.name}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  return (
    <Modal title={`Mời thành viên vào "${organization.name}"`} onClose={onClose}>
      <p>
        Chia sẻ link hoặc mã QR bên dưới. Bất kỳ ai có link/quét mã đều có thể tự đăng ký
        và được thêm vào tổ chức này, không cần admin duyệt thêm.
      </p>

      <div className="form-group">
        <label>Invite link</label>
        <div className="invite-link-row">
          <input type="text" readOnly value={inviteUrl} onFocus={(e) => e.target.select()} />
          <button type="button" className="btn btn-secondary btn-small" onClick={handleCopy}>
            {copied ? 'Đã sao chép!' : 'Copy link'}
          </button>
        </div>
      </div>

      <div className="invite-qr-container" ref={qrRef}>
        <QRCodeCanvas value={inviteUrl} size={200} includeMargin />
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-primary" onClick={handleDownload}>
          Tải QR (PNG)
        </button>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Đóng
        </button>
      </div>

      {organization.is_active === false && (
        <p className="error-message">
          Tổ chức này đang bị vô hiệu hoá (is_active = false), link mời sẽ không dùng được cho
          đến khi được kích hoạt lại.
        </p>
      )}
    </Modal>
  );
}

export default OrganizationInviteModal;
